module.exports = __webpack_public_path__ + "img/bank-ms.5f0e7a16.png";